/** Rendering owner per map; entries are removed on the last layer removal. */
export const renderers = new WeakMap();
